import { Card, CardContent } from '@material-ui/core'
import React from 'react'
import { ExerciseSentenceBuilderModel } from '../../../../store/services/Exercise/types'
import styles from './SentenceBuilderView.module.scss'

interface Props {
  exercise: ExerciseSentenceBuilderModel
}

export const SentenceBuilderView = ({ exercise }: Props) => {
  return (
    <Card>
      <CardContent>
        {exercise.data.wordOrSentenceUs.split(' ').map((word, index) => (
          <span
            key={`${word}__${index}`}
            className={`${styles.word} ${exercise.data.missingIndexesUs?.includes(index) ? styles.missing : ''}`}>
            {word}
          </span>
        ))}
        <div>Distractors: {exercise.data.distractorsUs?.join(', ')}</div>
      </CardContent>
    </Card>
  )
}
